<template lang="pug">
  v-text-field(v-if="field.type === 'v-text-field' && show"            v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails")
  v-textarea(v-else-if="field.type === 'v-textarea' && show"           v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails")
  tiptap-input(v-else-if="field.type === 'tiptap-input' && show"       v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label")
  div(v-else-if="field.type === 'v-select' && show"): v-select(        v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails" :items="selectItemsFor")
  div(v-else-if="field.type === 'v-select--projekt' && show"): v-autocomplete(v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails" :items="projekte")
  input-datetime(v-else-if="field.type === 'input-datetime' && show"   v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails")
  input-date(v-else-if="field.type === 'input-date' && show"           v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails")
  v-checkbox(v-else-if="field.type === 'v-checkbox' && show"           v-model="values[field.columnId]"       :disabled="disabled" :rules="rules" :error-messages="errorMessages" :label="field.label" :hint="field.hint" :persistent-hint="field.persistentHint" :clearable="field.clearable" :hideDetails="field.hideDetails" :color="field.color" true-value="true" false-value="false")
  div(v-else-if="field.type === 'html' && show"                                                               :disabled="disabled" :rules="rules" :error-messages="errorMessages" v-html="field.label")
  v-btn(v-else-if="field.type === 'v-btn' && show" :type="field.subtype" @click.prevent="buttonClicked()"     :disabled="status.loading || status.success && field.subtype !== 'reset'" :loading="field.subtype === 'submit' && status.loading"                                                                                 :color="field.color") {{field.label}}
  v-alert.fodyn-field-message(v-else-if="field.type === 'successmessage' && show" :value="!!status.success"                               :dismissible="field.clearable" color="success" @input="buttonClicked('reset')"      ) <div class="fodyn-field__alert" v-html="field.label"></div>
  v-alert.fodyn-field-message(v-else-if="field.type === 'errormessage' && show"   :value="!!(status.error || status.errors[''].length)"   :dismissible="field.clearable" color="error"   @input="buttonClicked('clearErrors')") <div class="fodyn-field__alert" v-html="field.label"></div><ul v-if="status.errors[''].length" class="mt-3"><template v-for="err in status.errors['']"><li> {{err}}</li></template></ul>
  div(v-else-if="field.type === 'v-data-table' && show")
    v-data-table(:items="tableData" :headers="tableColumns")
      template(v-slot:items="{ item }")
        template(v-for="column in tableColumns")
          td {{item[column.value]}}

</template>

<style lang="stylus" scoped>
.fodyn-field__alert > p:last-child
  margin-bottom 0

</style>

<script>
import gql from 'graphql-tag'

export default {
  props: ['values', 'field', 'fields', 'model', 'status'],
  name: 'extra-fodyn-field',
  apollo: {
    projekte: {
      query: gql`query ExtraFodynFieldProjekte {
        projekte(order: "name") {
          text: namePnr
          value: id
        }
      }`,
      skip() {
        return !this.field || this.field.type != 'v-select--projekt'
      }
    },
    tableData: {
      query: gql`query ExtraFodynIndexData($model: String!, $columns: [String!]!) {
        tableData: fodynModelIndex(model: $model, columns: $columns)
      }`,
      variables() {
        return {
          model: this.model.name,
          columns: this.model.columns.map(col => col.name)
        }
      },
      skip() {
        return !this.field || this.field.type != 'v-data-table' || this.tableColumns.length === 0
      },
      update(response) {
        return response.tableData.map(data => JSON.parse(data))
      }
    }
  },
  computed: {
    show() {
      const conditions = this.field && this.field.conditions || []
      const values = this.values
      return conditions.length === 0 || conditions.every((condition) => {
        let ok = true
        const value = values[condition.columnId]
        if (condition.type === 'eq') {
          ok = ok && value == condition.value
        } else if (condition.type === 'neq') {
          ok = ok && value != condition.value
        } else if (condition.type === 'lt') {
          ok = ok && value < condition.value
        } else if (condition.type === 'gt') {
          ok = ok && value > condition.value
        } else if (condition.type === 'truthy') {
          ok = ok && !!value && value != 'false'
        } else if (condition.type === 'falsy') {
          ok = ok && (!value || value == 'false')
        } else {
          console.error('unknown condition', condition)
        }
        return condition.action == 'show' ? ok : !ok
      })
    },
    errorMessages() {
      return this.status.errors[this.field.columnId] || []
    },
    rules() {
      return []
    },
    disabled() {
      return this.status.success
    },
    selectItemsFor() {
      const field = this.field
      const validationIds = field.validationIds
      const validation = this.model.validations.find((v) => validationIds.indexOf(v.id) > -1)
      if (validation && validation.values) {
        return validation.values.map((val) => {
          const index = val.lastIndexOf(":")
          if (index > -1) {
            const text = val.substring(0, index);
            const value = val.substring(index + 1);
            return { text, value }
          } else {
            return { text: val, value: val }
          }
        })
      } else {
        return []
      }
    },
    tableColumns() {
      const columns = {}
      this.model.columns.forEach((column) => {
        columns[column.id] = column
      })
      return (this.fields || []).filter((field) => field.type === 'table-col').map((field) => {
        return {
          text: field.label,
          value: (columns[field.columnId] || {}).name
        }
      })
    },
  },
  methods: {
    buttonClicked(type) {
      this.$emit('buttonClick', type || this.field.subtype)
    }
  },
}
</script>
